// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body {
  margin: 0;
  padding: 0;
  width: 100%;
  overflow-x: hidden;
}

.Home_main__dWXub {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-bottom: 50px;
}

.Home_section__pGRLp {
    text-align: center;
}

.Home_section__pGRLp h1 {
    color: #406343;
    font-size: 35px;
    margin-bottom: 10px;
}

.Home_section__pGRLp h2 {
    color: #406343;
    font-size: 35px;
    margin-bottom: 10px;
}

.Home_section__pGRLp span{
    font-weight: bold;
    font-size: 18px;
}

.Home_main__dWXub p {
    color: #7f7f7f;
    font-weight: bold;
    line-height: 1.8;
    margin-bottom: 10px;
}










/* Medium devices (tablets, 768px and up) */
@media (min-width: 768px) {
  .Home_container__iMzzl, .Home_container-md__01tbN {
    max-width: 720px;
  }
}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) {
  .Home_container__iMzzl, .Home_container-lg__gIo6c {
    max-width: 960px;
  }
}

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {
  .Home_container__iMzzl, .Home_container-xl__qlDR8 {
    max-width: 1100px;
  }
}

/* XX-Large devices (larger desktops, 1400px and up) */
@media (min-width: 1400px) {
  .Home_container__iMzzl, .Home_container-xxl__vtv06 {
    max-width: 1220px;
  }
}

/* XXX-Large devices (extra large desktops, 1600px and up) */
@media (min-width: 1600px) {
  .Home_container__iMzzl, .Home_container-xxxl__-YnlI {
    max-width: 1500px;
  }
}

/* 4K and larger displays (1920px and up) */
@media (min-width: 1920px) {
  .Home_container__iMzzl, .Home_container-4k__M29Ee {
    max-width: 1550px;
  }
}`, "",{"version":3,"sources":["webpack://./src/website/Home/Home.module.css"],"names":[],"mappings":";AACA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;AACvB;;;;;;;;;;;AAWA,2CAA2C;AAC3C;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA,2CAA2C;AAC3C;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA,wDAAwD;AACxD;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA,sDAAsD;AACtD;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA,4DAA4D;AAC5D;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA,2CAA2C;AAC3C;EACE;IACE,iBAAiB;EACnB;AACF","sourcesContent":["\r\n* {\r\n  margin: 0;\r\n  padding: 0;\r\n  box-sizing: border-box;\r\n}\r\n\r\nhtml, body {\r\n  margin: 0;\r\n  padding: 0;\r\n  width: 100%;\r\n  overflow-x: hidden;\r\n}\r\n\r\n.main {\r\n    width: 100%;\r\n    display: flex;\r\n    justify-content: center;\r\n    margin-bottom: 50px;\r\n}\r\n\r\n.section {\r\n    text-align: center;\r\n}\r\n\r\n.section h1 {\r\n    color: #406343;\r\n    font-size: 35px;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.section h2 {\r\n    color: #406343;\r\n    font-size: 35px;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.section span{\r\n    font-weight: bold;\r\n    font-size: 18px;\r\n}\r\n\r\n.main p {\r\n    color: #7f7f7f;\r\n    font-weight: bold;\r\n    line-height: 1.8;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n/* Medium devices (tablets, 768px and up) */\r\n@media (min-width: 768px) {\r\n  .container, .container-md {\r\n    max-width: 720px;\r\n  }\r\n}\r\n\r\n/* Large devices (desktops, 992px and up) */\r\n@media (min-width: 992px) {\r\n  .container, .container-lg {\r\n    max-width: 960px;\r\n  }\r\n}\r\n\r\n/* Extra large devices (large desktops, 1200px and up) */\r\n@media (min-width: 1200px) {\r\n  .container, .container-xl {\r\n    max-width: 1100px;\r\n  }\r\n}\r\n\r\n/* XX-Large devices (larger desktops, 1400px and up) */\r\n@media (min-width: 1400px) {\r\n  .container, .container-xxl {\r\n    max-width: 1220px;\r\n  }\r\n}\r\n\r\n/* XXX-Large devices (extra large desktops, 1600px and up) */\r\n@media (min-width: 1600px) {\r\n  .container, .container-xxxl {\r\n    max-width: 1500px;\r\n  }\r\n}\r\n\r\n/* 4K and larger displays (1920px and up) */\r\n@media (min-width: 1920px) {\r\n  .container, .container-4k {\r\n    max-width: 1550px;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `Home_main__dWXub`,
	"section": `Home_section__pGRLp`,
	"container": `Home_container__iMzzl`,
	"container-md": `Home_container-md__01tbN`,
	"container-lg": `Home_container-lg__gIo6c`,
	"container-xl": `Home_container-xl__qlDR8`,
	"container-xxl": `Home_container-xxl__vtv06`,
	"container-xxxl": `Home_container-xxxl__-YnlI`,
	"container-4k": `Home_container-4k__M29Ee`
};
export default ___CSS_LOADER_EXPORT___;
